import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Filter = (props) => {
  const [ready, setReady] = useState(false);
  const { fullList } = useSelector((state) => state);
  const [form, setForm] = useState({ filter: {}, offset: 0, limit: 10 });
  let arr = { ...form };
  let initFunction = () => {
    setReady(false);
    if (localStorage.getItem("usersCoordinatorsFilter")) {
      arr.filter = JSON.parse(localStorage.getItem("usersCoordinatorsFilter"));
      setForm(arr);
    }
    setReady(true);
  };

  const saveFilter = (data) => {
    if (data) {
      props.setFilter(data.filter);
      props.getList(1, data.filter);
    } else {
      props.setFilter(form.filter);
      props.getList(1, form.filter);
    }
  };

  useEffect(() => {
    if (!ready) {
      initFunction();
    }
  }, []);

  const setSelect = (e) => {
    arr = { ...form };

    if (
      arr.filter[e.target.accessKey] &&
      arr.filter[e.target.accessKey].includes(e.target.id)
    ) {
      const index = arr.filter[e.target.accessKey].indexOf(e.target.id);
      if (index > -1) {
        arr.filter[e.target.accessKey].splice(index, 1);
      }
    } else {
      if (arr.filter[e.target.accessKey]) {
        arr.filter[e.target.accessKey].push(e.target.id);
      } else {
        arr.filter[e.target.accessKey] = [];
        arr.filter[e.target.accessKey].push(e.target.id);
      }
    }

    setForm(arr);
  };
  const leaveClick = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      localStorage.setItem("usersCoordinatorsFilter", JSON.stringify(form.filter));
      saveFilter();
      props.setModal(false);
    }
  };
  const resetClick = () => {
    arr = { filter: [] };
    setForm(arr);
    localStorage.removeItem("usersCoordinatorsFilter");
    saveFilter(arr);
  };

  return (
    <div className="apFilterContainer" onBlur={leaveClick} tabIndex="0">
      <div className="apFilterHeader">
        <h4>Параметри фільтра</h4>
        <div style={{ display: "flex" }}>
          <button
            style={{ marginRight: "20px" }}
            className="secondarySmallRoundedButtonTextDefault"
            onClick={resetClick}
          >
            Скинути
          </button>
          <button
            className="secondarySmallRoundedButtonTextDefault"
            onClick={leaveClick}
          >
            OK
          </button>
        </div>
      </div>
      <div className="apFilterGroupBlock">
        <span>Регіони</span>
        <div className="apFilterButtonsBlock">
          {fullList.Regions.map((el) => {
            return (
              <button
                id={el.id}
                key={el.id}
                accessKey="regionId"
                className={
                  form.filter.regionId &&
                  form.filter.regionId.length > 0 &&
                  form.filter.regionId.includes(el.id)
                    ? "secondarySmallButtonTextActive"
                    : "secondarySmallButtonTextDefault"
                }
                onClick={setSelect}
              >
                {el.title}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Filter;
